<template>
    <b-col cols="12" xl="4" class="healthyCommunityMainBlock my-3 px-2" @click="click">
        <base-card titleClass="healthyCommunityTitle" class="healthyCommunityBlockHeight pointer">
            <base-icon :src="img" alt="" :height="$store.state.isMobile ? '30' : '42'" :width="$store.state.isMobile ? '30' : '42'" color="blue" :class="{ 'd-inline-block': $store.state.isMobile, 'mr-2': $store.state.isMobile }"></base-icon>
            <p class="neu-card-title my-3">{{title}}</p>
            <p class="description-block-healthy-community" v-html="description"></p>
            <div v-if="blockEnabled">
                <p class="my-3" style="margin-bottom: 0 !important;" @click.stop="goSection(sectionId)" v-if="showPendingPushNotificationsInLanding(sectionId) && !soonLabel">
                    <base-button class="btnReadNotificationsHealthyCommunity" white><b-icon-bell class="pointer"></b-icon-bell> {{getPendingPushNotificationsMessage(sectionId)}}</base-button>
                </p>
                <base-button white v-if="!showPendingPushNotificationsInLanding(sectionId) && !soonLabel" class="btnAccessHealthyCommunity my-3"><span>{{ $t('accessBtn') }}</span></base-button>
            </div>
            <div v-else>
                <b-badge class="mt-3" variant="info">{{ $t('only-subscriptors') }}</b-badge>
            </div>
            <p v-if="soonLabel" style="margin-bottom: 0"><b-badge class="mt-3 soon-label-healthy-community" :class="{ 'blink': blinkSoonLabelActive }" variant="primary">{{ $t('soon-label') }}</b-badge></p>
        </base-card>
    </b-col>
</template>

<script>
import forumMixin from '@/mixins/forum.mixin'
import BaseCard from '@/components/base/ui/BaseCard'
import BaseButton from '@/components/base/buttons/BaseButton'
import { HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION, WHO_IN_HEALTH_COMMUNITY_SECTION } from '@/constants/healthyCommunitySections'
import { BBadge } from 'bootstrap-vue'

export default ({
    name: 'healthy-community-vertical-card',
    mixins: [forumMixin],
    components: {
        BaseCard,
        BaseButton,
        BBadge
    },
    props: {
        path: String,
        soonLabel: Boolean,
        sectionId: String,
        img: String,
        title: String,
        description: String,
        onlySubscribers: Boolean
    },
    data () {
        return {
            blinkSoonLabelActive: false
        }
    },
    created () {
        this.$store.state.forum.sectionId = null
    },
    computed: {
        blockEnabled () {
            return this.onlySubscribers ? this.$store.getters['session/healthyCommunityActive'] : true
        }
    },
    methods: {
        goToPath (sectionId) {
            if (!this.$store.getters['session/isLogged'] && (sectionId === HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION || sectionId === WHO_IN_HEALTH_COMMUNITY_SECTION)) {
                this.logIn(this.getHealthyCommunityPathUrl(this.path))
                return
            }
            this.$router.push(this.getHealthyCommunityPathUrl(this.path))
        },
        getPendingPushNotificationsMessage (sectionId) {
            let numberNotifications = this.$store.state.forum.userBasicInfo.pushNotificationsSectionId.filter(x => x === sectionId).length
            if (numberNotifications === 1) {
                return this.$t('newPushNotifications', { plural: '', numberNotifications: numberNotifications })
            } else if (numberNotifications > 1) {
                return this.$t('newPushNotifications', { plural: 's', numberNotifications: numberNotifications })
            }
        },
        showPendingNotificationBySection (sectionId) {
            this.showPushNotifications(sectionId)
        },
        goSection (sectionId) {
            this.pushNotificationsReaded(sectionId)
            this.$router.push(this.getHealthyCommunityPathUrl(this.getForumPathBySectionId(sectionId)))
        },
        showPendingPushNotificationsInLanding (sectionId) {
            return this.$store.state.forum.userBasicInfo.pushNotificationsSectionId.filter(x => x === sectionId).length > 0
        },
        highlightSoonLabel () {
			this.blinkSoonLabelActive = true
			setTimeout(() => {
				this.blinkSoonLabelActive = false
			}, 4000)
		},
        click () {
            if (this.soonLabel) {
                this.highlightSoonLabel()
            } else if (!this.blockEnabled) {
                this.$store.dispatch('showSharedDialog', {
					content: this.$t(`only-subscriptors-warning`),
					okBtnText: this.$t('dialog.ok-button'),
					size: 'sm'
				})
            } else {
                this.goToPath(this.sectionId)
            }
        }
    }
})
</script>
<style lang="scss">
    .healthyCommunityMainBlock{
        /* @media only screen and (min-width: 1200px) { */
            max-width: 570px;
        /* } */
        @media only screen and (max-width: 575px) {
            height: 100% !important;
        }
    }
    .healthyCommunityBlockHeight{
        // @media only screen and (min-width: 756px) {
            // height: 100% !important;
        // }
        text-align: center !important;
        margin: 2%;
        min-height: 301px;
        // padding-top: 2rem !important;
        /* @media only screen and (min-width: 1200px) {
           max-height: 250px;
        } */
    }
    .healthyCommunityImageSize{       
        margin-bottom: 1rem;       
        width: 100%;
        /* height: 250px;
        @include media(mobile, tablets) {
            height: 150px;
        }
        @media only screen and (min-width: 2100px) {
           width: 80%;
        } */
    }
    .healthyCommunityTitle{
        color: $blue !important;
        @media only screen and (min-width: 1003px) and (max-width: 1586px) {
           height: 51px !important;
        }
        @media only screen and (min-width: 576px) and (max-width: 1002px) {
           height: 81px !important;
        }
    }

    .btnAccessHealthyCommunity{
        margin-bottom: 0 !important;
        /* @include screen-xl-grid-max { */
            padding: 0.5rem 1.5rem !important;
        /* } */
        /* position: absolute;
        transform: translate(-50%, -50%);
        bottom: 0; */
    }

    .btnReadNotificationsHealthyCommunity {
        font-size: 11px;
        padding: 0.5rem 1.5rem;
        /* @include screen-xl-grid-max {
            padding: 0.4rem 1rem !important;
        } */
        // position: absolute;
        // transform: translate(-50%, -50%);
        // bottom: 0;
        // width: max-content !important;
    }

    .description-block-healthy-community {
        margin-top: 0;
        margin-bottom: 0;
        @media only screen and (min-width: 1621px) {
            min-height: 45px;
        }
        @media only screen and (min-width: 1334px) and (max-width: 1620px) {
            min-height: 67.5px;
        }
        @media only screen and (min-width: 1140px) and (max-width: 1333px) {
            min-height: 90px;
        }
    }
    .neu-card-title{
        color: #3238C4;
        font-weight: bold;
        font-size: 1.25rem;
        margin: 0;
    }
    @media only screen and (min-width: 1200px) {
        .healthyCommunityMainBlock .neu-card{
            padding-left: 3.2rem !important;
            padding-right: 3.2rem !important;
        }
    }
    .soon-label-healthy-community {
        position: relative;
        margin-top: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/healthy-community/HealthyCommunityVerticalCard.vue